var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_4839_6315)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19C16.9973 19 20.5 20.5424 20.5 23.9286C20.5 25.7035 19.8109 26.5 18.3529 26.5H7.64706C6.18907 26.5 5.5 25.7035 5.5 23.9286C5.5 20.5424 9.00271 19 13 19ZM23.5 19C27.4973 19 31 20.5424 31 23.9286C31 25.7035 30.3109 26.5 28.8529 26.5H23C22.4477 26.5 22 26.0523 22 25.5C22 24.9477 22.4477 24.5 23 24.5L28.9128 24.5003C28.9298 24.5005 28.9439 24.5009 28.9554 24.5017L28.968 24.503L28.9704 24.4882C28.9809 24.407 28.9945 24.2672 28.9987 24.0606L29 23.9286C29 22.0954 26.5125 21 23.5 21C23.0723 21 22.6018 21.03 22.1302 21.0909C21.5825 21.1615 21.0812 20.7748 21.0105 20.227C20.9398 19.6793 21.3266 19.178 21.8743 19.1073C22.431 19.0355 22.987 19 23.5 19ZM13 21C9.98749 21 7.5 22.0954 7.5 23.9286C7.5 24.2089 7.51695 24.3908 7.52958 24.4882L7.531 24.503L7.54456 24.5017L7.56385 24.5008L18.4288 24.5005C18.4389 24.5008 18.4477 24.5012 18.4554 24.5017L18.468 24.503L18.4704 24.4882C18.483 24.3908 18.5 24.2089 18.5 23.9286C18.5 22.0954 16.0125 21 13 21ZM23.5 9C25.8479 9 27.75 10.9021 27.75 13.25C27.75 15.5979 25.8479 17.5 23.5 17.5C21.1521 17.5 19.25 15.5979 19.25 13.25C19.25 10.9021 21.1521 9 23.5 9ZM13 9C15.3479 9 17.25 10.9021 17.25 13.25C17.25 15.5979 15.3479 17.5 13 17.5C10.6521 17.5 8.75 15.5979 8.75 13.25C8.75 10.9021 10.6521 9 13 9ZM23.5 11C22.2567 11 21.25 12.0067 21.25 13.25C21.25 14.4933 22.2567 15.5 23.5 15.5C24.7433 15.5 25.75 14.4933 25.75 13.25C25.75 12.0067 24.7433 11 23.5 11ZM13 11C11.7567 11 10.75 12.0067 10.75 13.25C10.75 14.4933 11.7567 15.5 13 15.5C14.2433 15.5 15.25 14.4933 15.25 13.25C15.25 12.0067 14.2433 11 13 11Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4839_6315",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkAds);
export default __webpack_public_path__ + "static/media/vk_ads.d0242ef3520d7302a52a86245a0bb664.svg";
export { ForwardRef as ReactComponent };